export const SPOT_PREDICTION_MINZOOM = 9;
